import 'apps/hiring/styles/components/add-behaviors.scss';
import React from 'react';
import AddTarget from 'apps/hiring/components/add-target';
import EditTarget from 'apps/hiring/components/edit-target';
import BrowseTargets from 'apps/hiring/components/browse-targets';
import PropTypes from 'prop-types';
import { InputEvent as SyntheticEvent } from 'library/helpers/synthetic-events';

class AddBehaviors extends React.Component {
  static defaultProps = {
    onChange: ()=>{},
    targets: []
  }

  handleAddTargets = (targets) => {
    this.props.onChange(new SyntheticEvent({
      name: `targets`,
      value: [...this.props.targets,...targets].filter((v,i,a)=>a.findIndex(x=>x.id===v.id)===i)
    }));
  }

  remove = (id) => {
    this.props.onChange(new SyntheticEvent({
      name: `targets`,
      value: [...this.props.targets].filter((v)=>v.id!==id)
    }));
  }

  mapTargets = ({ id, name }) => (
    <div key={id} className="hiring-behavior-row">
      <span>{ name }</span>
      <div>
        <button disabled={this.props.disabled} onClick={()=>this.remove(id)}>REMOVE</button>
      </div>
    </div>
  )

  render() {
    const {
      disabled,
      noExisting=false
    } = this.props;

    return (
      <div className="add-behaviors">
        <h2>Add Targets to Evaluate Applicant Soft Skills</h2>
        <div className="add-behaviors-header">
          {!noExisting &&
            <BrowseTargets
              type="button"
              onTargets={this.handleAddTargets}
              exclude={this.props.targets}
              className="button-theme button-flex" disabled={disabled}
            >
              Browse Existing Targets
            </BrowseTargets>
          }
          <AddTarget disabled={disabled} className="button-flex button-primary" type="button" onTargets={this.handleAddTargets}>Create New Target <span>+</span></AddTarget>
        </div>
        <div className="add-behaviors-body">
          {
            this.props.targets.map(this.mapTargets)
          }
        </div>
      </div>
    );
  }
}

AddBehaviors.propTypes = {
  targets: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  noExisting: PropTypes.bool
};

export default AddBehaviors;
